export type Palette = {
	blackPrimary: string;
	blackSecondary: string;
	blackMuffled: string;
	blackDisabled: string;
	blackStealthy: string;
	whitePrimary: string;
	whiteSecondary: string;
	whiteMuffled: string;
	whiteDisabled: string;
	whiteStealthy: string;
	accentPrimary: string;
	accentPrimaryHover: string;
	accentPrimaryPressed: string;
	accentPrimaryDisabled: string;
	dangerPrimary: string;
	warningPrimary: string;
	bgDark: string;
	bgLight: string;
}

const palette: Palette = {
	blackPrimary: '#262626',
	blackSecondary: '#8c8c8c',
	blackMuffled: '#4d4d4d',
	blackDisabled: '#bfbfbf',
	blackStealthy: '#ebebeb',
	whitePrimary: '#ffffff',
	whiteSecondary: 'rgba(255, 255, 255, 0.65)',
	whiteMuffled: 'rgba(255, 255, 255, 0.8)',
	whiteDisabled: 'rgba(255, 255, 255, 0.4)',
	whiteStealthy: 'rgba(255, 255, 255, 0.2)',
	accentPrimary: '#26d06d',
	accentPrimaryHover: '#51d98a',
	accentPrimaryPressed: '#00c853',
	accentPrimaryDisabled: '#26d06d66',
	dangerPrimary: '#ff3a48',
	warningPrimary: '#ffc107',
	bgDark: '#3e4757',
	bgLight: '#f5f8fa'
};

export {
	palette
}
